console.clear();
let rings = document.querySelectorAll(".kg-sweet-inner");
let ringDur = 2;
for (let i = 0; i < rings.length; i++) {
  let tl = gsap.timeline({
    delay: i * ringDur,
    repeat: -1,
    repeatDelay: ringDur / 2,
    defaults: { ease: "none" }
  });
  tl.to(rings[i], { duration: ringDur, attr: { r: 150 } });
  tl.to(rings[i], { duration: 1, opacity: 1 }, 0);
  tl.to(rings[i], {
    duration: ringDur / 2,
    opacity: 0,
    attr: { r: 240, "stroke-width": 10 }
  });
}
